import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { ControlledSelect } from '@common/components/inputs/controlledInput/ControlledSelect';
import { LineText } from '@common/components/fragments/LineText';
import { usePayslipPeriodOptions } from '@/app/hooks/usePayslipPeriodOptions';
import { getDateFromPeriod } from '@/app/utils/dateUtils';
import AuditsExportsPostPayrollAnalysisExport from '@/app/spraypaint/audits/exports/AuditsExportsPostPayrollAnalysisExport';
import {
  SubformComponent,
  SubCardFieldsComponent,
  SubModule,
} from '@/modules/admin/audits/components/submodules/types';

export const jsonApiType = AuditsExportsPostPayrollAnalysisExport.jsonapiType;

export type Values = {
  payslipPeriod: string;
};

export const defaultValues: Values = {
  payslipPeriod: dayjs()
    .startOf('month')
    .subtract(1, 'month')
    .endOf('month')
    .format('YYYY-MM-DD'),
};

function createExportStrategy(
  data: Values,
): AuditsExportsPostPayrollAnalysisExport {
  return new AuditsExportsPostPayrollAnalysisExport({
    payslipPeriod: data.payslipPeriod,
  });
}

export const FormComponent: SubformComponent = ({ control }) => {
  const { t } = useTranslation();
  const payslipPeriodOptions = usePayslipPeriodOptions();

  return (
    <ControlledSelect
      label={t(
        'activerecord.attributes.audits/exports/post_payroll_analysis_export.payslip_period',
        {
          ns: 'rails',
        },
      )}
      className="mt-20"
      control={control}
      defaultValue={undefined}
      name="exportStrategy.params.payslipPeriod"
      options={payslipPeriodOptions}
      required
    />
  );
};

export const CardFieldsComponent: SubCardFieldsComponent<
  AuditsExportsPostPayrollAnalysisExport
> = ({ strategy }) => {
  const { t } = useTranslation();

  return (
    <>
      <LineText
        label={t('activerecord.attributes.audits/export.export_strategy', {
          ns: 'rails',
        })}
        value={t(
          'activerecord.models.audits/exports/post_payroll_analysis_export',
          {
            ns: 'rails',
          },
        )}
      />
      <LineText
        label={t(
          'activerecord.attributes.audits/exports/post_payroll_analysis_export.payslip_period',
          {
            ns: 'rails',
          },
        )}
        value={getDateFromPeriod(strategy.payslipPeriod)}
      />
    </>
  );
};

export const AuditsExportsPostPayrollAnalysisExportSubmodule: SubModule<
  Values,
  AuditsExportsPostPayrollAnalysisExport
> = {
  jsonApiType,
  defaultValues,
  FormComponent,
  CardFieldsComponent,
  createExportStrategy,
};
